module.exports = __webpack_public_path__ + "img/ArrivedPointA.d6dba578.png";